module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-card', {
    ref: "card",
    staticClass: "card-border",
    attrs: {
      "body-style": {
        padding: 0
      }
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "title",
    staticStyle: {
      "line-height": "36px"
    }
  }, [_vm._v("Gates")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "element-loading-text": "Loading...",
      "data": _vm.gates,
      "highlight-current-row": "",
      "height": _vm.tableHeight,
      "stripe": ""
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "FullName_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "img-circle",
          staticStyle: {
            "width": "50px",
            "float": "left"
          },
          attrs: {
            "src": _vm.getAsset(scope.row.ImagePath, 'student'),
            "alt": ""
          }
        }), _vm._v("\n            " + _vm._s(scope.row.FullName_EN) + "  "), _c('br'), _vm._v("   " + _vm._s(scope.row.FullName_AR) + "\n\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Gate Name",
      "prop": "Name_EN",
      "align": "left",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\n            " + _vm._s(scope.row.Name_EN) + "  "), _c('br'), _vm._v("   " + _vm._s(scope.row.Name_AR) + "\n\n      ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "First Reader Time",
      "prop": "FirstReaderTime",
      "align": "left",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Last Reader Time",
      "prop": "LastReaderTime",
      "align": "left",
      "sortable": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "pagination",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [20, 30, 50, 70, 100],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74feb867"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/attendance/Gate.vue
// module id = 616
// module chunks = 1